import { useEffect } from "react";
import { HighlightColours } from "../../../models/HighlightColors";
import { HighlightObjectFactory } from "../../../models/HighlightObjectFactory";
import { useHighlightDispatch } from "../../highlightProvider/HighlightProvider";

export { useColumnHighlight };

function useColumnHighlight(
  index: number,
  highlightKey: string,
  leftXPercent: number,
  rightXPercent: number,
  showHighlights: boolean,
) {
  let highlightDispatch: any = undefined;
  try {
    highlightDispatch = useHighlightDispatch();
  } catch (e) {}
  // define different highlight key for Key and Value highlights
  useEffect(() => {
    if (!highlightDispatch) {
      return;
    }

    highlightDispatch({
      type: "add",
      highlight: HighlightObjectFactory.createColumnHighlightExact(
        highlightKey,
        HighlightColours.getHighlightColor(index),
        leftXPercent,
        rightXPercent,
        showHighlights,
        () => null,
      ),
    });

    return () => {
      highlightDispatch({
        type: "remove",
        highlight: HighlightObjectFactory.createColumnHighlightExact(
          highlightKey,
          HighlightColours.getHighlightColor(index),
          leftXPercent,
          rightXPercent,
          showHighlights,
          () => null,
        ),
      });
    };
  }, [index, highlightKey, leftXPercent, rightXPercent, showHighlights]);
}
